@if(breadcrumbItems(); as breadcrumbItems)
{
    <div class="px-1 pb-3 d-flex">
    @if(breadcrumbItems.length) {
            @for (breadcrumbItem of breadcrumbItems; track breadcrumbItem)
            {
                <breadcrumb-item [id]="breadcrumbItem.id" 
                                 [data]="breadcrumbItem" 
                                 (click)="removeBreadcrumb(breadcrumbItem)"/>                
            }
        }
    </div>
}